<template>
  <template v-if="item.pointsOfInterest">
    <SSection :desktop-full="true" :title="$t('views.cottage.interests')">
      <TProse :responsive="false" :clear="false">
        <span v-html="item.pointsOfInterest" />
      </TProse>
    </SSection>
  </template>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'

type itemType = Pick<CottagePage, 'pointsOfInterest'>

interface propsInterface {
  item: itemType
}

defineProps<propsInterface>()
</script>
